<template>
    <svg
        v-if="network === 'instagram'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <rect x="3" y="3" width="18" height="18" rx="5.4" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" stroke="none" />
    </svg>

    <svg
        v-else-if="network === 'tiktok'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path
            d="M16.5 3h-3.2v12.4a2.6 2.6 0 11-2.6-2.6c.28 0 .55.04.8.12V9.7a5.9 5.9 0 00-.8-.06 5.86 5.86 0 105.86 5.86V9.35a7.1 7.1 0 004.1 1.3V7.4a4.13 4.13 0 01-3.36-3.4c-.03-.33-.05-.66-.05-1z"
        />
    </svg>

    <svg
        v-else-if="network === 'facebook'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path
            d="M22 12a10 10 0 10-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.8-1.6 1.6V12h2.7l-.4 2.9h-2.3v7A10 10 0 0022 12z"
        />
    </svg>

    <svg
        v-else-if="network === 'whatsapp'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path
            d="M12 2a10 10 0 00-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1012 2zm5.6 14.2c-.24.67-1.4 1.3-1.93 1.35-.5.05-1.13.07-1.82-.11-.42-.13-.96-.31-1.65-.6-2.9-1.25-4.8-4.17-4.94-4.36-.15-.19-1.2-1.6-1.2-3.05 0-1.45.76-2.16 1.03-2.46.27-.3.59-.37.79-.37l.57.01c.18.01.43-.07.67.51.24.6.83 2.05.9 2.2.07.15.12.32.02.51-.1.19-.15.31-.29.48-.15.17-.31.38-.44.51-.15.15-.3.31-.13.6.17.29.76 1.25 1.63 2.02 1.12.99 2.06 1.3 2.35 1.45.29.15.46.13.63-.08.17-.19.73-.85.92-1.14.19-.29.39-.24.65-.15.27.1 1.7.8 1.99.95.29.15.48.22.55.34.07.13.07.72-.17 1.39z"
        />
    </svg>

    <svg
        v-else-if="network === 'youtube'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path
            d="M23 7.2a3 3 0 00-2.1-2.1C19 4.5 12 4.5 12 4.5s-7 0-8.9.6A3 3 0 001 7.2 31 31 0 00.5 12 31 31 0 001 16.8a3 3 0 002.1 2.1c1.9.6 8.9.6 8.9.6s7 0 8.9-.6a3 3 0 002.1-2.1A31 31 0 0023 7.2zM9.8 15.3V8.7L15.9 12l-6.1 3.3z"
        />
    </svg>

    <svg
        v-else-if="network === 'twitter' || network === 'x'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path
            d="M18.9 1.15h3.68l-8.04 9.19L24 22.85h-7.41l-5.8-7.59-6.64 7.59H.46l8.6-9.83L0 1.15h7.59l5.24 6.93 6.07-6.93zm-1.29 19.5h2.04L6.49 3.24H4.3l13.31 17.41z"
        />
    </svg>

    <svg
        v-else-if="network === 'linkedin'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path
            d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 110-4.13 2.06 2.06 0 010 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.55C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.72C24 .77 23.2 0 22.22 0z"
        />
    </svg>

    <svg
        v-else-if="network === 'twitch'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path
            d="M11.57 4.71h1.72v5.15h-1.72zm4.72 0H18v5.15h-1.71zM6 0L1.71 4.29v15.42h5.15V24l4.28-4.29h3.43L22.29 12V0zm14.57 11.14l-3.43 3.43h-3.43l-3 3v-3H6.86V1.71h13.71z"
        />
    </svg>

    <svg
        v-else-if="network === 'pinterest'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path
            d="M12 0a12 12 0 00-4.37 23.17c-.1-.94-.2-2.43.04-3.47.22-.97 1.4-6.16 1.4-6.16s-.36-.72-.36-1.78c0-1.67.97-2.92 2.17-2.92 1.02 0 1.51.77 1.51 1.68 0 1.03-.65 2.56-.99 3.98-.28 1.19.6 2.16 1.77 2.16 2.12 0 3.76-2.24 3.76-5.47 0-2.86-2.06-4.86-5-4.86a5.18 5.18 0 00-5.4 5.19c0 1.03.4 2.13.89 2.73.1.12.11.22.08.34l-.33 1.36c-.05.22-.17.27-.4.16-1.5-.7-2.43-2.89-2.43-4.65 0-3.78 2.75-7.26 7.93-7.26 4.16 0 7.4 2.97 7.4 6.93 0 4.14-2.6 7.47-6.22 7.47-1.21 0-2.36-.63-2.75-1.38l-.75 2.85c-.27 1.04-1 2.35-1.49 3.15A12 12 0 1012 0z"
        />
    </svg>

    <svg
        v-else-if="network === 'threads'"
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path
            d="M12.19 24h-.01c-3.58-.02-6.33-1.2-8.18-3.51C2.35 18.44 1.5 15.59 1.47 12.01v-.02c.03-3.58.88-6.43 2.53-8.48C5.85 1.2 8.6.02 12.18 0h.01c2.75.02 5.04.73 6.83 2.1 1.68 1.29 2.86 3.13 3.51 5.47l-2.04.57c-1.1-3.96-3.9-5.99-8.3-6.02-2.91.02-5.11.94-6.54 2.72C4.31 6.5 3.62 8.91 3.59 12c.03 3.09.72 5.5 2.06 7.16 1.43 1.78 3.63 2.7 6.54 2.72 2.62-.02 4.36-.63 5.8-2.05 1.65-1.61 1.62-3.59 1.09-4.8-.31-.71-.87-1.3-1.63-1.75-.19 1.35-.62 2.45-1.28 3.27-.89 1.1-2.14 1.7-3.73 1.79-1.2.07-2.36-.22-3.26-.8-1.06-.69-1.69-1.74-1.75-2.96-.07-1.19.4-2.29 1.33-3.08.88-.76 2.12-1.21 3.58-1.29a13.85 13.85 0 013.02.14c-.13-.74-.38-1.33-.75-1.76-.51-.59-1.31-.88-2.36-.89h-.03c-.84 0-1.99.23-2.72 1.32L7.73 7.85c.98-1.45 2.57-2.26 4.48-2.26h.04c3.19.02 5.1 1.98 5.29 5.39l.32.14c1.49.7 2.58 1.76 3.15 3.07.8 1.82.87 4.79-1.55 7.16-1.85 1.81-4.09 2.63-7.28 2.65zm1-11.69c-.24 0-.49.01-.74.02-1.84.1-2.98.95-2.92 2.14.07 1.26 1.45 1.84 2.78 1.77 1.22-.07 2.82-.54 3.09-3.71a10.5 10.5 0 00-2.21-.22z"
        />
    </svg>

    <svg
        v-else
        :class="`h-${height} w-${width}`"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18" />
        <path d="M12 3a13.5 13.5 0 010 18M12 3a13.5 13.5 0 000 18" />
    </svg>
</template>

<script>
export default {
    name: "SocialIcon",
    props: {
        network: {
            type: String,
            required: true
        },
        height: {
            type: Number,
            default: 6
        },
        width: {
            type: Number,
            default: 6
        }
    }
};
</script>
